/**
 * Copy der Bewerbenden-Infopage, nach dem Entwurf von Florian.
 * Die FAQ-Antworten ab Frage 2 sind neu formuliert und noch abzustimmen.
 */

export const LINKS = {
  appStore: 'https://apps.apple.com/de/app/aivy/id1611347679',
  googlePlay: 'https://play.google.com/store/apps/details?id=app.aivy.app',
  privacy: 'https://www.aivy.app/datenschutz',
  imprint: 'https://www.aivy.app/impressum',
  support: 'mailto:hi@aivy.app'
}

const de = {
  ui: {
    chapters: 'Kapitel',
    cue: 'Scroll los',
    locale: 'de-DE'
  },
  chapters: {
    hero: 'Eingeladen',
    ablauf: 'So läuft es ab',
    fair: 'Warum das gut ist',
    tipps: 'Vier Tipps',
    faq: 'Häufige Fragen',
    app: 'Die App'
  },
  hero: {
    eyebrow: 'Für Bewerbende',
    lines: ['Du wurdest', 'eingeladen.', 'Gut so.'],
    text: 'Ein Unternehmen möchte mehr über dich wissen als deinen Lebenslauf. Hier steht, was dich erwartet und wie du dich vorbereitest.',
    ctaFlow: 'So läuft der Test ab',
    ctaFaq: 'Häufige Fragen',
    company: 'Aivy als Unternehmen einsetzen?',
    companyLink: 'Hier entlang'
  },
  ablauf: {
    title: 'So läuft es ab.',
    steps: [
      {
        title: 'Link öffnen',
        text: 'Du bekommst ihn per Mail. Am besten auf dem Handy öffnen.'
      },
      {
        title: 'Kurze Aufgaben lösen',
        text: 'Kleine Spiele und Fragen, jede etwa zwei Minuten. Wie viele, legt das Unternehmen fest.'
      },
      {
        title: 'Stärken sehen',
        text: 'Am Ende bekommst du eine Rückmeldung zu deinen Stärken.'
      }
    ],
    inbox: 'Posteingang',
    sender: 'Dein Wunscharbeitgeber',
    subject: 'Deine Einladung zum Aivy-Test',
    preview: 'Wir möchten dich besser kennenlernen.',
    greeting: 'Hallo!',
    body: 'Danke für deine Bewerbung. Im nächsten Schritt lernst du in ein paar kurzen Spielen deine Stärken kennen.',
    button: 'Test starten',
    profile: 'Dein Stärkenprofil',
    strengths: [
      { title: 'Empathie', text: 'Du erkennst schnell, wie es anderen geht.' },
      { title: 'Vorausplanen', text: 'Du denkst mehrere Schritte voraus.' },
      { title: 'Merkfähigkeit', text: 'Du behältst viele Details im Kopf.' }
    ]
  },
  fair: {
    title: 'Warum das gut für dich ist.',
    text: 'Bei Aivy zählt, was du kannst. Nicht, wie gut du dich auf Papier verkaufst.',
    points: [
      'Alle bekommen dieselben Aufgaben.',
      'Alter, Herkunft und Geschlecht spielen keine Rolle.',
      'Es gibt kein Bestanden oder Durchgefallen.',
      'Du lernst dabei selbst etwas über dich.'
    ]
  },
  tipps: {
    title: 'Vier Tipps für den Test.',
    tips: [
      {
        title: 'Ruhiger Ort',
        text: 'Ein paar Minuten ohne Ablenkung reichen.'
      },
      {
        title: 'Handy geladen',
        text: 'Und eine stabile Internetverbindung.'
      },
      {
        title: 'Ehrlich antworten',
        text: 'Es gibt keine richtigen Antworten bei Persönlichkeit und Werten.'
      },
      {
        title: 'Nicht pauken',
        text: 'Lernen kannst du dafür nicht. Die Aufgaben erklären sich selbst.'
      }
    ]
  },
  faq: {
    title: 'Häufige Fragen',
    items: [
      {
        q: 'Wie lange dauert der Test?',
        a: 'Jede Aufgabe dauert etwa zwei Minuten. Wie viele Aufgaben du bekommst, entscheidet das Unternehmen. Meist bist du in 15 bis 30 Minuten fertig.'
      },
      {
        q: 'Kann ich durchfallen?',
        a: 'Nein. Es gibt kein Bestanden oder Durchgefallen. Aivy zeigt, wo deine Stärken liegen und wie gut sie zu den Anforderungen der Stelle passen.'
      },
      {
        q: 'Kann ich mich vorbereiten?',
        a: 'Lernen kannst du dafür nicht, und das musst du auch nicht. Jede Aufgabe erklärt sich selbst. Such dir einen ruhigen Ort und nimm dir ein paar Minuten Zeit.'
      },
      {
        q: 'Wer sieht meine Ergebnisse?',
        a: 'Das Unternehmen, das dich eingeladen hat. Deine Daten liegen auf Servern in Frankfurt, werden nach der DSGVO verarbeitet und nach einer festen Frist automatisch gelöscht.'
      },
      {
        q: 'Was, wenn etwas technisch nicht klappt?',
        a: 'Öffne den Link einfach noch einmal. Klappt es dann immer noch nicht, schreib uns an hi@aivy.app.'
      },
      {
        q: 'Bekomme ich selbst ein Ergebnis?',
        a: 'Ja. Am Ende bekommst du eine Rückmeldung zu deinen Stärken. Wenn du deine Ergebnisse in der Aivy-App speicherst, hast du jederzeit Zugriff darauf.'
      }
    ],
    privacy: 'Mehr zum Datenschutz'
  },
  app: {
    eyebrow: 'Auch ohne Einladung',
    title: 'Dein Stärkenprofil, kostenlos in der App.',
    text: 'Finde heraus, welche Berufe zu dir passen. 9 von 10 Nutzer:innen finden Aivy spannender als andere Orientierungstests.',
    appStore: ['Laden im', 'App Store'],
    googlePlay: ['Jetzt bei', 'Google Play'],
    reviews: [
      {
        quote:
          '„Gibt Rückmeldung über eigene Interessen und Fähigkeiten. Das ist sehr hilfreich.“',
        who: 'tohowabohu, App Store'
      },
      {
        quote: '„Spielerisch seine berufliche Laufbahn konkretisieren.“',
        who: 't.friedman, App Store'
      },
      {
        quote: '„Die Aufgaben sind abwechslungsreich.“',
        who: 'Kronexx, App Store'
      }
    ],
    phoneTitle: 'Passende Berufe',
    sample: 'Beispiel',
    jobs: [
      ['Kommunikationsdesign', 92],
      ['Projektmanagement', 86],
      ['Marketing', 81],
      ['Personalwesen', 74]
    ],
    privacy: 'Datenschutz',
    imprint: 'Impressum',
    top: 'Nach oben'
  }
}

const en = {
  ui: {
    chapters: 'Chapters',
    cue: 'Scroll to start',
    locale: 'en-US'
  },
  chapters: {
    hero: 'Invited',
    ablauf: 'How it works',
    fair: 'Why it’s good',
    tipps: 'Four tips',
    faq: 'FAQ',
    app: 'The app'
  },
  hero: {
    eyebrow: 'For candidates',
    lines: ['You’ve been', 'invited.', 'Good news.'],
    text: 'A company wants to learn more about you than your CV shows. Here is what to expect and how to get ready.',
    ctaFlow: 'How the test works',
    ctaFaq: 'FAQ',
    company: 'Using Aivy as a company?',
    companyLink: 'This way'
  },
  ablauf: {
    title: 'How it works.',
    steps: [
      {
        title: 'Open the link',
        text: 'You get it by email. Best opened on your phone.'
      },
      {
        title: 'Solve short tasks',
        text: 'Small games and questions, each about two minutes. The company decides how many.'
      },
      {
        title: 'See your strengths',
        text: 'At the end you get feedback on your strengths.'
      }
    ],
    inbox: 'Inbox',
    sender: 'Your future employer',
    subject: 'Your invitation to the Aivy test',
    preview: 'We would like to get to know you better.',
    greeting: 'Hi there!',
    body: 'Thanks for applying. In the next step, a few short games show you your strengths.',
    button: 'Start test',
    profile: 'Your strengths profile',
    strengths: [
      { title: 'Empathy', text: 'You quickly sense how others feel.' },
      { title: 'Planning ahead', text: 'You think several steps ahead.' },
      { title: 'Memory', text: 'You keep lots of details in mind.' }
    ]
  },
  fair: {
    title: 'Why this is good for you.',
    text: 'With Aivy, what counts is what you can do. Not how well you sell yourself on paper.',
    points: [
      'Everyone gets the same tasks.',
      'Age, background and gender play no role.',
      'There is no pass or fail.',
      'You learn something about yourself along the way.'
    ]
  },
  tipps: {
    title: 'Four tips for the test.',
    tips: [
      {
        title: 'A quiet place',
        text: 'A few minutes without distractions are enough.'
      },
      {
        title: 'Phone charged',
        text: 'And a stable internet connection.'
      },
      {
        title: 'Answer honestly',
        text: 'There are no right answers on personality and values.'
      },
      {
        title: 'Don’t cram',
        text: 'You can’t study for it. The tasks explain themselves.'
      }
    ]
  },
  faq: {
    title: 'Frequently asked questions',
    items: [
      {
        q: 'How long does the test take?',
        a: 'Each task takes about two minutes. The company decides how many tasks you get. Most people are done in 15 to 30 minutes.'
      },
      {
        q: 'Can I fail?',
        a: 'No. There is no pass or fail. Aivy shows where your strengths lie and how well they match the requirements of the role.'
      },
      {
        q: 'Can I prepare?',
        a: 'You can’t study for it, and you don’t need to. Every task explains itself. Find a quiet place and take a few minutes.'
      },
      {
        q: 'Who sees my results?',
        a: 'The company that invited you. Your data is stored on servers in Frankfurt, processed under the GDPR and deleted automatically after a set period.'
      },
      {
        q: 'What if something doesn’t work?',
        a: 'Simply open the link again. If it still doesn’t work, write to us at hi@aivy.app.'
      },
      {
        q: 'Do I get a result myself?',
        a: 'Yes. At the end you get feedback on your strengths. If you save your results in the Aivy app, you can access them at any time.'
      }
    ],
    privacy: 'More on data protection'
  },
  app: {
    eyebrow: 'Even without an invitation',
    title: 'Your strengths profile, free in the app.',
    text: 'Find out which careers suit you. 9 out of 10 users find Aivy more exciting than other orientation tests.',
    appStore: ['Download on the', 'App Store'],
    googlePlay: ['Get it on', 'Google Play'],
    reviews: [
      {
        quote:
          '“Gives feedback on your own interests and abilities. That is really helpful.”',
        who: 'tohowabohu, App Store (translated)'
      },
      {
        quote: '“A playful way to shape your career path.”',
        who: 't.friedman, App Store (translated)'
      },
      {
        quote: '“The tasks are varied.”',
        who: 'Kronexx, App Store (translated)'
      }
    ],
    phoneTitle: 'Matching careers',
    sample: 'Example',
    jobs: [
      ['Communication design', 92],
      ['Project management', 86],
      ['Marketing', 81],
      ['Human resources', 74]
    ],
    privacy: 'Privacy',
    imprint: 'Imprint',
    top: 'Back to top'
  }
}

export const CANDIDATE_COPY = { de, en }
